import React from "react";
import "../../assets/styles/login.css";
import MessageScreen from "../app/MessageScreen";
import DataLayerTrigger  from '../app/GTM';

export default class Login extends React.Component {
  getSiteId = (provider) => {
    switch (provider) {
      case "bit": {
        return "43a31578-d0c4-5aeb-f1bc-c8c33b3cedb7";
      }
      case "leumi": {
        return "f4fd98c5-c456-4689-b4dc-794bffc679bc";
      }
      default: {
        return "ca9475f8-c727-4010-89ca-0537d7d2b1a2";
      }
    }
  };
  clientParams = {
    guid: this.getSiteId(window.provider),
    logo: false,
    modal: false,
    loginType: 2,
    decoration: false,
  };

  componentDidMount() {
    this.listenToMessageHandler();
  }

  handleServerErrors() {
    let error = this.props.error;

    return (
      <MessageScreen
        provider={this.props.provider}
        message={error.text}
        onTryAgain={this.props.onGetCards}
        onClose={this.props.onCloseMessage}
        type="error"
      />
    );
    return null;
  }

  listenToMessageHandler() {
    window.addEventListener("message", (event) => {
      this.messageHandler(event);
    });
  }

  messageHandler(event) {
    let messageData;
    const calConnectIframe = document.getElementById("calConnectIframe");
    //var token = sessionStorage.getItem("token");
    var token = null;
    if (token) {
      let { onLoginSuccess } = this.props;
      onLoginSuccess(token);
    } else {
      try {
        messageData = JSON.parse(event.data);
        switch (messageData.operation) {
          case "connectReady":
            calConnectIframe.contentWindow.postMessage(
              { operation: "params", params: this.clientParams },
              "*"
            );
            break;
          case "token":
            let { onLoginSuccess } = this.props;

            onLoginSuccess(messageData.token);
            break;
          default:
            break;
        }
      } catch (error) {}
    }
  }

  render() {
    if (this.props.error) {
      return this.handleServerErrors();
    } else {
      return (
        <a>
        <DataLayerTrigger event="OnLogivEvent" data={{ buttonLabel: 'Test' , seconeTestLabel: 'Test2'}} />
        <section className="login-wrapper color-n bg-t">
          <iframe
            id="calConnectIframe"
            className="cal-connect-iframe"
            src={window.settings.calConnect}
            frameBorder="0"
            scrolling="no"
          ></iframe>
        </section>
        </a>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.jsx